var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.9 207",
    style: {
      enableBackground: "new 0 0 210.9 207"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#A93651;}\n\t.st2{fill:url(#SVGID_00000137117173088296033290000006249586626294579845_);}\n\t.st3{fill:url(#SVGID_00000078737126463091029020000016724628755036613560_);}\n\t.st4{fill:url(#SVGID_00000134235413871934133610000010950750781427746720_);}\n\t.st5{fill:url(#SVGID_00000176721705094910651140000014879149938718258313_);}\n\t.st6{fill:#681642;}\n\t.st7{fill:url(#SVGID_00000135683742942939151610000009973034216829894792_);}\n\t.st8{opacity:0.6;fill:url(#SVGID_00000172429589909879337410000010606749171667884933_);enable-background:new    ;}\n\t.st9{opacity:0.6;fill:url(#SVGID_00000130625190092624984900000000553196323556349610_);enable-background:new    ;}\n\t.st10{fill:url(#SVGID_00000108282245230509173120000011273700213530017712_);}\n\t.st11{fill:url(#SVGID_00000093898288625919866120000018081580958011508882_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3012,
    y1: 152.6273,
    x2: 27.3012,
    y2: 205.7943,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#564ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.6,23c0,0-4.4-20.4-25.2-20.9C8.5,1.7,9.6,29.2,9.6,29.2l3.7-2.2c0,0-1.4-18.6,10.2-20.8 c11.6-2.3,21.1,4,21.1,4s-29.3-10.1-40,4.7S2.6,58.3,23.2,55C43.8,51.8,54.6,23,54.6,23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,31.4c0,0,24.6-23.1,49.6-6.8l2.1-0.7c0,0-23.5-18.1-51.3,1.1L0,31.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6,16.4c0,0,28.2-14.1,49.2,1.6l-2-3.7c0,0-9.8-11.2-46.2,0.6L3.6,16.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,51.9c0,0-0.5-30.1,36.6-26L45,26.5c0,0-34.8-2-32.5,27.1L9.7,51.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085224610108602864340000014590266824500338820_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.5069,
    y1: 158.433,
    x2: 183.5069,
    y2: 207.89,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#564ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085224610108602864340000014590266824500338820_)"
    },
    d: "M156,24.6c0,0,2.9-26.1,26.5-24.5 c23.5,1.6,17.6,33.2,17.6,33.2s1.4-25.4-12.6-30.2s-21.6,3.8-21.6,3.8S180.8-2,200,8.3s12.9,42.8-15.8,41.2L156,24.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054251345741602980550000012350175316506621582_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.6585,
    y1: 87.49,
    x2: 104.6585,
    y2: 191.4907,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3949E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1391,
    style: {
      stopColor: "#3C48DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3005,
    style: {
      stopColor: "#4545CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    style: {
      stopColor: "#533FB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6532,
    style: {
      stopColor: "#673896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    style: {
      stopColor: "#802F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054251345741602980550000012350175316506621582_)"
    },
    d: "M176.1,120.4c0,0-4-24.4-4.6-38.4 c-0.5-14-10.4-26.5-18.7-33.7c-1.7-1.5-3.7-2.9-5.6-4.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.1-0.1-0.1-0.1 c-7-4.2-14.1-6.3-14.1-6.3S82,35.4,65,41.6c-2.7,1-5.2,2.3-7.3,3.8l0,0c-11.1,7.9-14.6,21.7-16.9,28.5c-2.7,8.1,1.2,17.4-9.7,42.8 c0,0-5.8-14.9-8.1-30.4c-2.2-14.7-2-39.7,8.1-50.9l0,0c0.5-0.6,1-1.1,1.6-1.6C49,19.5,87.3,16.4,105.4,16.4s39.5-0.3,62.8,11.7 c4.3,2.2,7.9,5.7,10.7,10C191.7,57.6,189.6,95.1,176.1,120.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046309656676953998790000012616392088238433709_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1496,
    y1: 0.89,
    x2: 24.1496,
    y2: 94.99,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046309656676953998790000012616392088238433709_)"
    },
    d: "M31.3,116.7c0,0-5.5,30.1-13.9,53.3 s15.3,37,15.3,37S15,190.8,19.3,170.6s13.5-43.1,13.4-57.7L31.3,116.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169532060402470423260000009030984189131315600_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.7581,
    y1: 5.09,
    x2: 182.7581,
    y2: 88.99,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169532060402470423260000009030984189131315600_)"
    },
    d: "M176.1,120.4c0,0,2.7,8.5,8.3,37.3 c5.7,28.8-5.7,45.1-5.7,45.1s11.2-12.2,10.7-31.5s-9.5-38.3-12.5-52.4L176.1,120.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.7,37.4c0,0-6-10.1-10.5-11.5S55.4,45.5,65.9,86.3c0,0-1.4-37.5,20.4-52.7c0,0,2.9,1.1,6.3,4 C92.6,37.6,97.2,37.8,97.7,37.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.4,43.6c0,0,19-0.1,28.6-10.4l4.1,5.2c0,0-3.9,10.3-26.2,9.8L146.4,43.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,40.7c0,0,10.6-10.3,22.6-14.9l-2.8-1.2c0,0-10.7,3.8-20.9,15.6L141,40.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.4,43.3c0,0-9-6-17.6-16.3L42,27.8c0,0,3.6,10.7,18.4,16L61.4,43.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,63.5c0,0-12.2-2.2-18.9-18.1l-2.2,8.2c0,0,7.3,15.2,18.2,18.2L44.6,63.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.2,37.1c0,0,21.1-16.3,38.5-15.7l2,0.6c0,0-17.7-0.8-37.7,15.1H113.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,25.9c0,0,26.2,1.5,42.5,11.9l1.5-0.1c0,0-11.9-11.7-41.7-12.7L46.3,25.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183946156947276464630000004349549295210801581_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.9198,
    y1: 53.6498,
    x2: 91.4,
    y2: 53.6498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#564ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183946156947276464630000004349549295210801581_)"
    },
    d: "M65.9,86.3c0,0,0.4-38.1,25.5-57.3l-8.5-8 C82.9,20.9,53.7,37.2,65.9,86.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118388207978566510360000007846445646160477577_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.9047,
    y1: 41.419,
    x2: 13.3809,
    y2: 106.4121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#00008E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000118388207978566510360000007846445646160477577_)",
      enableBackground: "new"
    },
    d: " M57.8,45.4c-11.1,7.9-14.6,21.7-16.9,28.5c-2.7,8.1,1.2,17.4-9.7,42.8c0,0-5.8-14.9-8.1-30.4c-2.2-14.7-2-39.7,8.1-50.9l0,0 c0,0,7.3,14.4,11.5,15.5C46.7,52.1,57.2,45.8,57.8,45.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128484313536616230330000003992379683974304421_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.2,
    y1: 78.75,
    x2: 187.4315,
    y2: 78.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3995,
    style: {
      stopColor: "#000094"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000128484313536616230330000003992379683974304421_)",
      enableBackground: "new"
    },
    d: " M176.1,120.4c0,0-4-24.4-4.6-38.4c-0.5-14-10.4-26.5-18.7-33.7c-1.7-1.5-3.7-2.9-5.6-4.1c2.4,1.4,9.7,5.2,19.5,6 c12,1,11.3-13.1,11.3-13.1l0.8,1C191.7,57.6,189.6,95.1,176.1,120.4z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.4,3.4c0,0,30.1,18,19.3,44.2l2.4-1.1c0,0,9.4-30.4-19.9-43.1C179.2,3.4,177.4,3.4,177.4,3.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.7,4c0,0,17.3,12,15.3,45.3l2.6-0.3c0,0,0.3-35-16.7-45H173.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.9,9.4c0,0,7.1,19.6-1,36c0,0,4.4-2.1,7.5-8.4c0,0,2.6-11.2,0.6-19.1C209.1,18,205.5,11.5,201.9,9.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081622523433801285000000017716644469493974944_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.2,
    y1: 158.49,
    x2: 170.2,
    y2: 185.0129,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081622523433801285000000017716644469493974944_)"
    },
    d: "M156.3,22.9c0,0,24.6-1.8,27.8,26.5 C184.1,49.4,180.2,28.4,156.3,22.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067202206581440856340000014440202228617780379_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.9786,
    y1: 39,
    x2: 54.6,
    y2: 39
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067202206581440856340000014440202228617780379_)"
    },
    d: "M54.6,23c0,0-23.6,5.3-31.4,32 C23.2,55,18.3,29.1,54.6,23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair1);
export default __webpack_public_path__ + "static/media/Hair1.297a4b2cf90092b9b124a04d6ac8e380.svg";
export { ForwardRef as ReactComponent };